export function isStandaloneMode(): boolean {
	return window.matchMedia && window.matchMedia("(display-mode: standalone)").matches
}
